module.exports = __webpack_public_path__ + "assets/img/ktz_img11.cd9408c9.png";